import '../../../styles/containers/Prayer/prayer.scss';
import '../../../styles/containers/Prayer/components/prayer-offering.scss';
import React, {useEffect, useState} from 'react'
import AnimatedLoader from '../../../components/AnimatedLoader';
import useMoengage from '../../../hooks/useMoengage';
import faiths from '../../../constants/PrayerFaithsConstants';
import NavigationSection from './NavigationSection';
import PrayerMusic from './PrayerMusic';
import WorshipOptions from './WorshipOptions';
import {Routes} from '../../../constants/RouterConstants';
import Button from '@mui/material/Button';
import axios from 'axios';


function PrayerOffering() {
    const [userId, setUserId] = useState('');
    const [selectedFaith, setSelectedFaith] = useState('');
    const [selectedGodObj, setSelectedGodObj] = useState({});
    const [selectedWorshipOptionObj, setSelectedWorshipOptionObj] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const isWebview=window.navigator.userAgent.includes ('wv');
    const [isPayroll, setIsPayroll] = useState(false);

    const trackEvent = useMoengage()[1];
    async function fetchUserPayrollOrNotInfo(endPoint, query) {
        var config = {
            method: 'get',
            url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
            headers: { 
              'Content-Type': 'application/json',
              'Access-Control-Allow-Credentials':'true',
              'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
              'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
              "Cache-Control": null,
              "X-Requested-With": null  
            },
        };
          
        return axios(config).then((response) => {
            if(response.status === 200) {
                return response.data;
            } else {
              throw new Error('Server Error');
            }
        })
    }
    useEffect(() => {
        const paramString = window.location.href.split('?')[1];
        const queryString = new URLSearchParams(paramString);
        let userIdParam, faithKey, godKey;
        queryString.forEach((value, key) => {
          if (key === 'userId') userIdParam = value;
          if (key === 'faith') faithKey = value;
          if (key === 'god') godKey = value;
        });
        if (!userIdParam || !faithKey || !godKey) return;
        else {
          setUserId(userIdParam);
          setSelectedFaith(faithKey);

          for(const faith of faiths) {
              if(faith.key===faithKey){
                  for(const god of faith.gods) {
                      if(god.key === godKey) {
                        setSelectedGodObj(god);
                        setSelectedWorshipOptionObj({gif:god.defaultWorshipGif});
                      }
                  }
              } 
          }

          fetchUserPayrollOrNotInfo('checkPayrolluserOrNot', `userId=${userIdParam}`)
            .then((userData) => {
                setIsPayroll(userData.isPayrollUser);
            })
            .catch(e => {
                console.log(e.toString());
            })

          setIsLoading(false);
        };
    },[]);
    
    const handleClick = () => {
        trackEvent('prayer_view_earnings_tapped', {});
        // console.log(isWebview,isPayroll);
        setTimeout(window.location.href = `https://mitra.vahan.co/payroll/view-earnings`,1000);
    }
    
    return isLoading || !selectedGodObj? (
        <AnimatedLoader containerStyle={{height: '100vh'}}/>
      ) :(<div className='__main-container'>
            <NavigationSection path={`${Routes.SELECT_GOD}`} search={`userId=${userId}&faith=${selectedFaith}`} isWebview={isWebview}/>
            {selectedWorshipOptionObj.gif &&
                <>
                    <div className='d-flex justify-content-center align-items-center'>
                        <img className='god-gif' src={selectedWorshipOptionObj.gif} alt="loading..." />
                    </div>
                    {selectedGodObj && <PrayerMusic link={selectedGodObj.prayerMusic} />}
                    <WorshipOptions selectedGodObj={selectedGodObj} setSelectedWorshipOptionObj={setSelectedWorshipOptionObj} />
                    {/* <div className="linkForGoToEarningsPage" style={{
                        height: '69px',
                        backgroundColor: 'rgba(211, 75, 24, 0.05)',
                        marginTop: '5%',
                    }} onClick={e =>
                        console.log("go to earnings button clicked.")

                        // redirect to next page, based on conditions.
                        // mongage fired.        setTimeout(window.location.href = `https://mitra.vahan.co/payroll/view-earnings`,1000);

                    }
                    >
                        <p style={{
                            fontSize: '16px',
                            fontFamily: 'Open Sans',
                            color: '#D34714',
                            textDecoration: 'underline',
                            textAlign: 'center',
                            marginTop: '5%',
                        }}>Go to My Earnings</p>
                    </div> */}
                </>
        }
        {userId && isPayroll==true && isWebview==true && <div className='d-flex justify-content-center align-items-center' className="go-to-my-earnings-page-div" style={{
            height: '69px',
            backgroundColor: 'rgba(211, 75, 24, 0.05)',
            marginTop: '5%',
        }} onClick={handleClick}>
            <span className='d-flex justify-content-center go-to-my-earnings'>Go to My Earnings</span>
        </div>}
    </div>
    )
}

export default PrayerOffering
